import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';

import { IS_LOCAL } from '~/config/environment';

import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import frCommon from './locales/fr/common.json';

export const defaultNS = 'common';

export const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
} as const;

export const FALLBACK_LNG = 'en';
export const I18N_LNG_STORAGE_KEY = 'i18nextLng';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  // .use(ChainedBackend)
  // detect user language
  // learn more:
  //  - https://github.com/i18next/i18next-browser-languageDetector
  //  - https://github.com/i18next/i18next-browser-languageDetector#adding-own-detection-functionality
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: FALLBACK_LNG,
    defaultNS,
    debug: IS_LOCAL,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      backends: [LocalStorageBackend, HttpBackend],
      backendOptions: [],
      cacheHitMode: 'refreshAndUpdateStore',
    },
    react: {
      bindI18nStore: 'added', // this way, when the HttpBackend delivers new translations (thanks to refreshAndUpdateStore), the UI gets updated
    },
    // detection: {
    //   lookupFromSubdomainIndex: 0,
    // },
    resources,
  });
